import { isAltTheme } from '@helpers/altTheme';
import SvgCalendar from '@img/icons/calendar.svg';
import SvgClock from '@img/icons/clock.svg';
import SvgLocation from '@img/icons/location.svg';
import SvgMobile from '@img/icons/mobile-screen-solid.svg';
import SvgPhone from '@img/icons/phone-solid.svg';
import SvgFacebook from '@img/logos/facebook.svg';
import SvgInstagram from '@img/logos/instagram.svg';
import SvgLinkedIn from '@img/logos/linkedin.svg';
import SvgX from '@img/logos/x-twitter.svg';
import Button, { LinkButton } from '@stories/Components/Buttons/Button/Button';
import Image from '@stories/Components/Misc/Image/Image';
import Search from '@stories/Components/Search/Search';
import * as React from 'react';
import S from './BasicHeroBanner.styles';
const BasicHeroBanner = ({ id, title, titleUrl, content, image, cta, includeBackgroundShapes, isNarrow, search, backgroundColor = 'primary', date, time, location, personDetails, modalCta, }) => {
    if (!title) {
        return null;
    }
    return (React.createElement(S.Container, { id: id, className: backgroundColor, "data-split-layout": !!image, "data-background-shapes": includeBackgroundShapes, narrow: isNarrow ?? (renderSnippetDetails() !== null && backgroundColor === 'primary') },
        includeBackgroundShapes && (React.createElement(S.BackgroundShapes, null,
            React.createElement(S.ShapeOne, null),
            React.createElement(S.ShapeTwo, null))),
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, null,
                renderSnippetDetails(),
                titleUrl ? (React.createElement("a", { href: titleUrl },
                    React.createElement(S.Title, { as: "h2" }, title))) : (React.createElement(S.Title, null, title)),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                personDetails && (React.createElement(S.Details, null,
                    personDetails.tel && (React.createElement("div", null,
                        React.createElement("strong", null, "Tel:"),
                        React.createElement("a", { href: `tel:${personDetails.tel}` },
                            getSvgIcon('tel'),
                            " ",
                            personDetails.tel))),
                    personDetails.mobile && (React.createElement("div", null,
                        React.createElement("strong", null, "Mobile:"),
                        React.createElement("a", { href: `tel:${personDetails.mobile}` },
                            getSvgIcon('mobile'),
                            " ",
                            personDetails.mobile))),
                    personDetails.social &&
                        personDetails.social.map((social, idx) => (React.createElement("div", { key: social.url || social.platform || idx },
                            React.createElement("strong", null, "Social:"),
                            React.createElement("a", { href: social.url, target: "_blank", rel: "noopener noreferrer" },
                                getSvgIcon(social.platform?.toLowerCase() || 'linkedin'),
                                "View ",
                                social.platform || 'LinkedIn')))))),
                modalCta ? (React.createElement(Button, { className: "js-modal-trigger", buttonType: "white" }, modalCta)) : cta && cta.text && cta.url ? (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { buttonType: isAltTheme(backgroundColor) || backgroundColor === 'neutral'
                            ? 'primary'
                            : 'secondary', buttonSize: titleUrl ? 'large' : 'default', href: cta.url, target: cta.target }, cta.text))) : null,
                search && React.createElement(Search, { ...search, visible: true, usedInBanner: true })),
            image && (React.createElement(S.ImageWrapper, { "data-photo": !!personDetails },
                React.createElement(Image, { fetchPriority: "high", loading: "eager", image: image, width: 306 }))))));
    function renderSnippetDetails() {
        if (date || time || location) {
            return (React.createElement("div", { className: "post-detail__snippets" },
                date && (React.createElement("div", { className: "post-detail__snippets-text" },
                    React.createElement(SvgCalendar, null),
                    " ",
                    date)),
                time && (React.createElement("div", { className: "post-detail__snippets-text" },
                    React.createElement(SvgClock, null),
                    " ",
                    time)),
                location && (React.createElement("div", { className: "post-detail__snippets-text" },
                    React.createElement(SvgLocation, null),
                    " ",
                    location))));
        }
        return null;
    }
    function getSvgIcon(icon) {
        switch (icon) {
            case 'tel':
                return React.createElement(SvgPhone, null);
            case 'mobile':
                return React.createElement(SvgMobile, null);
            case 'linkedin':
                return React.createElement(SvgLinkedIn, null);
            case 'x':
            case 'twitter':
                return React.createElement(SvgX, null);
            case 'facebook':
                return React.createElement(SvgFacebook, null);
            case 'instagram':
                return React.createElement(SvgInstagram, null);
            default:
                return null;
        }
    }
};
export default BasicHeroBanner;
